var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#E3DEEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0174 16.0697C13.8863 16.0697 12.9709 15.1544 12.9709 14.0232C12.9709 12.892 13.8863 11.9767 15.0174 11.9767C16.1486 11.9767 17.064 12.892 17.064 14.0232C17.064 15.1544 16.1486 16.0697 15.0174 16.0697ZM15.0174 13.093C14.504 13.093 14.0872 13.5097 14.0872 14.0232C14.0872 14.5367 14.504 14.9534 15.0174 14.9534C15.5309 14.9534 15.9477 14.5367 15.9477 14.0232C15.9477 13.5097 15.5309 13.093 15.0174 13.093Z",
    fill: "#0F0F0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4826 25H15.0174C10.9765 25 9.25 23.2735 9.25 19.2326V14.7674C9.25 10.7265 10.9765 9 15.0174 9H17.9942C18.2993 9 18.5523 9.25302 18.5523 9.55814C18.5523 9.86326 18.2993 10.1163 17.9942 10.1163H15.0174C11.5867 10.1163 10.3663 11.3367 10.3663 14.7674V19.2326C10.3663 22.6633 11.5867 23.8837 15.0174 23.8837H19.4826C22.9133 23.8837 24.1337 22.6633 24.1337 19.2326V15.5116C24.1337 15.2065 24.3867 14.9535 24.6919 14.9535C24.997 14.9535 25.25 15.2065 25.25 15.5116V19.2326C25.25 23.2735 23.5235 25 19.4826 25Z",
    fill: "#0F0F0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7151 14.5814C21.41 14.5814 21.157 14.3284 21.157 14.0232V9.55813C21.157 9.33487 21.2909 9.1265 21.4993 9.04464C21.7077 8.96278 21.9458 9.00743 22.1095 9.16371L23.5979 10.6521C23.8137 10.8679 23.8137 11.2251 23.5979 11.4409C23.3821 11.6567 23.0249 11.6567 22.8091 11.4409L22.2733 10.9051V14.0232C22.2733 14.3284 22.0202 14.5814 21.7151 14.5814Z",
    fill: "#0F0F0F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2267 11.6046C20.0853 11.6046 19.9439 11.5525 19.8323 11.4409C19.6164 11.2251 19.6164 10.8679 19.8323 10.6521L21.3206 9.16369C21.5364 8.94788 21.8937 8.94788 22.1095 9.16369C22.3253 9.37951 22.3253 9.73671 22.1095 9.95253L20.6211 11.4409C20.5095 11.5525 20.3681 11.6046 20.2267 11.6046Z",
    fill: "#0F0F0F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3066 22.7303C10.128 22.7303 9.94939 22.641 9.8452 22.4847C9.67404 22.2317 9.74102 21.8819 9.99404 21.7108L13.6629 19.2475C14.4666 18.7117 15.5754 18.7712 16.3047 19.3889L16.5503 19.6047C16.9224 19.9247 17.555 19.9247 17.9196 19.6047L21.0154 16.948C21.8043 16.2708 23.0471 16.2708 23.8433 16.948L25.0564 17.9898C25.2871 18.1908 25.3168 18.5405 25.1159 18.7787C24.915 19.0094 24.5578 19.0391 24.3271 18.8382L23.114 17.7963C22.7419 17.4763 22.1168 17.4763 21.7447 17.7963L18.6489 20.4531C17.8601 21.1303 16.6173 21.1303 15.821 20.4531L15.5754 20.2373C15.2331 19.947 14.6675 19.9173 14.288 20.1777L10.6266 22.641C10.5224 22.7005 10.4108 22.7303 10.3066 22.7303Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditPhoto);
export default __webpack_public_path__ + "static/media/icon-edit-photo.a16c281b1ee2a70f4f2bdffdfe8011d5.svg";
export { ForwardRef as ReactComponent };